import { render, staticRenderFns } from "./Platforms.vue?vue&type=template&id=13a89e69&scoped=true"
import script from "./Platforms.vue?vue&type=script&lang=js"
export * from "./Platforms.vue?vue&type=script&lang=js"
import style0 from "./Platforms.vue?vue&type=style&index=0&id=13a89e69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a89e69",
  null
  
)

export default component.exports